const menuToggle = document.querySelector('#menu-toggle')
const notificationBanner = document.querySelector('.notification-banner')
const menu = document.querySelector('#menu')
const allElements = document.body.querySelectorAll('*')
menuToggle.addEventListener('click', function (ev) {
	allElements.forEach((element) => {
		if (
			!element.classList.contains('menu-mobile') &&
			!element.closest('.menu-mobile') &&
			!element.classList.contains('login-modal') &&
			!element.closest('.login-modal')
		) {
			element.classList.toggle('hide-element')
		}
	})
	document.querySelector('body')
	menu.classList.toggle('hidden')
})

const navContainer = document.getElementById('nav-container')
const isTopWhite =
	navContainer.getAttribute('data-is-top-white') === 'true' ? true : false
const navBody = document.getElementById('nav-body')
const navLogoLetters = Array.from(document.querySelectorAll('.nav-logo > path'))
const navLogo = document.querySelector('.nav-logo')
navLogoLetters.splice(0, 1)
const [navLogoGradient1, navLogoGradient2] = document.querySelectorAll(
	'#paint0_linear_38_715 > stop',
)
const navLink = document.querySelectorAll('.nav-link')
const navTransparentButton = document.querySelectorAll('.nav-transparent-btn')
const navTransparentButtonMobileIcon = document.querySelectorAll(
	'.nav-transparent-btn > svg  path',
)
const navSecondaryButton = document.querySelectorAll('.nav-secondary-btn')
const screenHeight = window.innerHeight
let navStartPosition = 0,
	navEndPosition = screenHeight,
	navStartPadding = window.innerWidth < 1280 ? 20 : 32,
	navEndPadding = 12,
	navLogoStartdimension = { width: 288, height: 36 },
	navLogoEnddimension = { width: 250, height: 32 },
	navPaddingDiff = navStartPadding - navEndPadding,
	navLogoDimensionDiff = {
		width: navLogoStartdimension.width - navLogoEnddimension.width,
		height: navLogoStartdimension.height - navLogoEnddimension.height,
	},
	white = [255, 255, 255],
	galaxyBlue = [21, 37, 52],
	transparentWhite = [255, 255, 255, 0.3],
	mistyBlue = [236, 241, 250, 1],
	ghostWhite = [248, 252, 255],
	whiteToGalaxyBlueDiff = [
		Math.abs(white[0] - galaxyBlue[0]),
		Math.abs(white[1] - galaxyBlue[1]),
		Math.abs(white[2] - galaxyBlue[2]),
	],
	ghostWhiteToGalaxyBlueDiff = [
		Math.abs(ghostWhite[0] - galaxyBlue[0]),
		Math.abs(ghostWhite[1] - galaxyBlue[1]),
		Math.abs(ghostWhite[2] - galaxyBlue[2]),
	],
	transparentWhiteToMistyBlueDiff = [
		Math.abs(transparentWhite[0] - mistyBlue[0]),
		Math.abs(transparentWhite[1] - mistyBlue[1]),
		Math.abs(transparentWhite[2] - mistyBlue[2]),
		Math.abs(transparentWhite[3] - mistyBlue[3]),
	]
if (!isTopWhite) {
	navContainer.style.backgroundColor = `rgba(255, 255, 255, 0)`
	navLink.forEach((link) => {
		link.style.color = 'rgb(255, 255, 255)'
	})
	navLogoLetters.forEach((letter) => {
		letter.style.fill = 'rgb(255, 255, 255)'
	})
	// navLogoIcon.style.fill="rgb(255, 255, 255)"
	navLogoGradient1.setAttribute('stop-color', 'rgb(255, 255, 255)')
	navLogoGradient2.setAttribute('stop-color', 'rgb(248, 252, 255)')
	// navLogoIcon.style.fill="linear-gradient(217deg, rgb(rgb(255, 255, 255)) 14.25%, rgb(248, 252, 255) 79.05%)"
	navTransparentButton.forEach((btn) => {
		btn.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
		btn.style.color = 'rgb(255, 255, 255)'
	})
	navSecondaryButton.forEach((btn) => {
		btn.style.backgroundColor = 'rgb(255,255,255)'
		btn.style.color = 'rgb(21, 37, 52)'
	})
	navTransparentButtonMobileIcon.forEach((line) => {
		line.style.stroke = 'rgb(255,255,255)'
	})
} else {
	navContainer.style.backgroundColor = `rgba(255, 255, 255)`
	navLink.forEach((link) => {
		link.style.color = `rgb(21, 37, 52)`
	})
	navLogoLetters.forEach((letters) => {
		letters.style.fill = `rgb(21, 37, 52)`
	})
	navLogoGradient1.setAttribute('stop-color', `rgb(21, 37, 52)`)
	navLogoGradient2.setAttribute('stop-color', `rgb(21, 37, 52)`)
	navSecondaryButton.forEach((btn) => {
		btn.style.backgroundColor = `rgb(21, 37, 52)`
		btn.style.color = `rgb(255, 255, 255)`
	})
	navTransparentButton.forEach((btn) => {
		btn.style.backgroundColor = `rgba(236, 241, 250, 1)`
		btn.style.color = `rgb(21, 37, 52)`
	})
	navTransparentButtonMobileIcon.forEach((line) => {
		line.style.stroke = 'rgb(21, 37, 52)'
	})
}
navBody.style.paddingTop = `${navStartPadding}px`
navBody.style.paddingBottom = `${navStartPadding}px`
navLogo.style.width = `${navLogoStartdimension.width}px`
navLogo.style.height = `${navLogoStartdimension.height}px`
window.addEventListener('scroll', function (ev) {
	if (notificationBanner) {
		notificationBanner.style.minHeight = window.scrollY === 0 ? '40px' : 0
		notificationBanner.style.height = window.scrollY === 0 ? '' : 0
		notificationBanner.style.padding = window.scrollY === 0 ? '12px' : 0
	}

	let currYOffset = window.scrollY,
		scrollPercentage =
			(currYOffset - navStartPosition) / (navEndPosition - navStartPosition),
		whiteToGalaxyBlue = [
			Math.round(white[0] - whiteToGalaxyBlueDiff[0] * scrollPercentage),
			Math.round(white[1] - whiteToGalaxyBlueDiff[1] * scrollPercentage),
			Math.round(white[2] - whiteToGalaxyBlueDiff[2] * scrollPercentage),
		],
		ghostWhiteToGalaxyBlue = [
			Math.round(white[0] - ghostWhiteToGalaxyBlueDiff[0] * scrollPercentage),
			Math.round(white[1] - ghostWhiteToGalaxyBlueDiff[1] * scrollPercentage),
			Math.round(white[2] - ghostWhiteToGalaxyBlueDiff[2] * scrollPercentage),
		],
		galaxyBlueToWhite = [
			Math.round(galaxyBlue[0] + whiteToGalaxyBlueDiff[0] * scrollPercentage),
			Math.round(galaxyBlue[1] + whiteToGalaxyBlueDiff[1] * scrollPercentage),
			Math.round(galaxyBlue[2] + whiteToGalaxyBlueDiff[2] * scrollPercentage),
		],
		transparentWhiteToMistyBlue = [
			Math.round(
				transparentWhite[0] -
					transparentWhiteToMistyBlueDiff[0] * scrollPercentage,
			),
			Math.round(
				transparentWhite[1] -
					transparentWhiteToMistyBlueDiff[1] * scrollPercentage,
			),
			Math.round(
				transparentWhite[2] -
					transparentWhiteToMistyBlueDiff[2] * scrollPercentage,
			),
			transparentWhite[3] +
				transparentWhiteToMistyBlueDiff[3] * scrollPercentage,
		]
	if (currYOffset > screenHeight) {
		navContainer.style.backgroundColor = `rgba(255, 255, 255)`
		navLink.forEach((link) => {
			link.style.color = `rgb(21, 37, 52)`
		})
		navLogoLetters.forEach((letters) => {
			letters.style.fill = `rgb(21, 37, 52)`
		})
		navLogoGradient1.setAttribute('stop-color', `rgb(21, 37, 52)`)
		navLogoGradient2.setAttribute('stop-color', `rgb(21, 37, 52)`)
		navSecondaryButton.forEach((btn) => {
			btn.style.backgroundColor = `rgb(21, 37, 52)`
			btn.style.color = `rgb(255, 255, 255)`
		})
		navTransparentButton.forEach((btn) => {
			btn.style.backgroundColor = `rgba(236, 241, 250, 1)`
			btn.style.color = `rgb(21, 37, 52)`
		})
		navTransparentButtonMobileIcon.forEach((line) => {
			line.style.stroke = 'rgb(21, 37, 52)'
		})
		navBody.style.paddingTop = navEndPadding
		navBody.style.paddingBottom = navEndPadding
		navLogo.style.width = `${navLogoEnddimension.width}px`
		navLogo.style.height = `${navLogoEnddimension.height}px`
	} else {
		if (!isTopWhite) {
			navContainer.style.backgroundColor = `rgba(255, 255, 255, ${
				scrollPercentage * 1
			})`
			navLink.forEach((link) => {
				link.style.color = `rgb(${whiteToGalaxyBlue[0]}, ${whiteToGalaxyBlue[1]}, ${whiteToGalaxyBlue[2]})`
			})
			navLogoLetters.forEach((letters) => {
				letters.style.fill = `rgb(${whiteToGalaxyBlue[0]}, ${whiteToGalaxyBlue[1]}, ${whiteToGalaxyBlue[2]})`
			})
			navLogoGradient1.setAttribute(
				'stop-color',
				`rgb(${whiteToGalaxyBlue[0]}, ${whiteToGalaxyBlue[1]}, ${whiteToGalaxyBlue[2]})`,
			)
			navLogoGradient2.setAttribute(
				'stop-color',
				`rgb(${ghostWhiteToGalaxyBlue[0]}, ${ghostWhiteToGalaxyBlue[1]}, ${ghostWhiteToGalaxyBlue[2]})`,
			)
			navSecondaryButton.forEach((btn) => {
				btn.style.backgroundColor = `rgb(${whiteToGalaxyBlue[0]}, ${whiteToGalaxyBlue[1]}, ${whiteToGalaxyBlue[2]})`
				btn.style.color = `rgb(${galaxyBlueToWhite[0]}, ${galaxyBlueToWhite[1]}, ${galaxyBlueToWhite[2]})`
			})
			navTransparentButton.forEach((btn) => {
				btn.style.backgroundColor = `rgba(${transparentWhiteToMistyBlue[0]}, ${transparentWhiteToMistyBlue[1]}, ${transparentWhiteToMistyBlue[2]}, ${transparentWhiteToMistyBlue[3]})`
				btn.style.color = `rgb(${whiteToGalaxyBlue[0]}, ${whiteToGalaxyBlue[1]}, ${whiteToGalaxyBlue[2]})`
			})
			navTransparentButtonMobileIcon.forEach((line) => {
				line.style.stroke = `rgb(${whiteToGalaxyBlue[0]}, ${whiteToGalaxyBlue[1]}, ${whiteToGalaxyBlue[2]})`
			})
		}
		navBody.style.paddingTop = `${Math.round(
			navStartPadding - navPaddingDiff * scrollPercentage,
		)}px`
		navBody.style.paddingBottom = `${Math.round(
			navStartPadding - navPaddingDiff * scrollPercentage,
		)}px`
		navLogo.style.width = `${Math.round(
			navLogoStartdimension.width -
				navLogoDimensionDiff.width * scrollPercentage,
		)}px`
		navLogo.style.height = `${Math.round(
			navLogoStartdimension.height -
				navLogoDimensionDiff.height * scrollPercentage,
		)}px`
	}
})

//////////////////////////////////
////////// Modals ///////////////
/// Login modal

const modals = document.querySelectorAll('.modal')
const loginModal = document.querySelector('.login-modal')
const loginModalToggleBtns = document.querySelectorAll('#loginBtn')

loginModalToggleBtns.forEach((btn) => {
	btn.onclick = function () {
		allElements.forEach((element) => {
			if (
				!element.classList.contains('menu-mobile') &&
				!element.closest('.menu-mobile') &&
				!element.classList.contains('login-modal') &&
				!element.closest('.login-modal')
			) {
				element.classList.remove('hide-element')
			}
		})
		if (
			loginModal.classList.contains('hidden') &&
			!menu.classList.contains('hidden')
		)
			menu.classList.add('hidden')
		loginModal.classList.toggle('hidden')
		loginModal.classList.toggle('block')
	}
})

modals.forEach((modal) => {
	const closeBtn = modal.querySelector('#closeButton > svg')
	closeBtn.onclick = function () {
		modal.classList.remove('block')
		modal.classList.add('hidden')
	}
})

window.onclick = function (event) {
	modals.forEach((modal) => {
		const background = modal.querySelector('#background')
		if (event.target == modal || event.target == background) {
			modal.classList.remove('block')
			modal.classList.add('hidden')
		}
	})
}
export default menuToggle
